// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__Htn1N","bg_main":"style_bg_main__9kI-f","bg_top":"style_bg_top__fLc48"};